// Ganga Farms — Header Glassmorphism Scroll Behavior
(function () {
  'use strict';

  const headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;

  let lastScroll = 0;
  const SCROLL_THRESHOLD = 60;

  function updateHeader() {
    const currentScroll = window.pageYOffset;

    if (currentScroll > SCROLL_THRESHOLD) {
      headerWrapper.classList.add('scrolled-glass');
    } else {
      headerWrapper.classList.remove('scrolled-glass');
    }

    lastScroll = currentScroll;
  }

  // Throttle for performance
  let ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        updateHeader();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // Run on load
  updateHeader();
})();
